<template>
  <v-btn
    small
    color="primary"
    dark
    fab
    class="elevation-0"
  >
    <v-icon> mdi-cart-plus</v-icon>
  </v-btn>
</template>

<script>
export default {
  methods: {},
  props: {
    visible: Boolean,
   
  },
  data() {
    return {};
  },
};
</script>
